import React, { useState } from "react";
import Reduction from "../../img/remise.png";

function Promo() {
  const [colorBase, setColorBase] = useState("#fbcfe8");
  const [txtColorBase, setTxtColorBase] = useState("#d53f8c");
  const [colorPro, setColorPro] = useState("#fbcfe8");
  const [txtColorPro, setTxtColorPro] = useState("#d53f8c");
  const [colorSuper, setColorSuper] = useState("#fbcfe8");
  const [txtColorSuper, setTxtColorSuper] = useState("#d53f8c");
  return (
    <div className="bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100">
      <div className="px-5 md:px-12 lg:px-32 xl:px-40 2xl:px-60 py-8 md:py-12 lg:py-20">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
          Devenir membre aujourd'hui
        </h2>

        <div class="relative">
          <div class="font-[sans-serif] text-[#333]">
            <div class="max-w-5xl mx-auto">
              <div class="text-center">
                <p className="py-5 poppins-semibold text-pink-600 text-center text-sm sm:text-base">
                  Bénéficiez de notre promotion jusqu'à 28 Septembre 2024
                </p>
              </div>

              <div class="grid lg:grid-cols-3 sm:grid-cols-2 gap-8 mt-8 max-sm:max-w-sm max-sm:mx-auto">
                <div
                  class="shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] rounded-md overflow-hidden transition-all duration-500 hover:scale-105"
                  onMouseEnter={() => {
                    setColorBase("#d53f8c");
                    setTxtColorBase("#ffffff");
                  }}
                  onMouseLeave={() => {
                    setColorBase("#fbcfe8");
                    setTxtColorBase("#d53f8c");
                  }}
                >
                  <div
                    class="h-28 text-center p-6"
                    style={{ backgroundColor: colorBase }}
                  >
                    <h3
                      class="text-2xl poppins-bold mb-1"
                      style={{ color: txtColorBase }}
                    >
                      Base - members
                    </h3>
                  </div>
                  <div class="h-24 w-24 mx-auto -mt-11 shadow-xl rounded-full bg-pink-50 border-2 flex flex-col items-center justify-center border-pink-50">
                    <img src={Reduction} alt="Promo" />
                  </div>
                  <div class="px-6 py-4 mt-4">
                    <p className="text-xl text-pink-600 text-center poppins-regular">
                      Gagner une reduction de 10% sur votre achat pendant 2 mois
                    </p>

                    <button
                      type="button"
                      class="w-full mt-8 px-2 py-2 poppins-semibold text-pink-600 bg-pink-200 hover:bg-pink-600 hover:text-white rounded uppercase transition-all duration-500 hover:scale-105"
                    >
                      Select
                    </button>

                    <p className="text-gray-400 mt-4 text-center">
                      "cliquez sur select et envoie un email pour votre demande"
                    </p>
                  </div>
                </div>

                <div
                  class="shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] rounded-md overflow-hidden transition-all duration-500 hover:scale-105"
                  onMouseEnter={() => {
                    setColorPro("#d53f8c");
                    setTxtColorPro("#ffffff");
                  }}
                  onMouseLeave={() => {
                    setColorPro("#fbcfe8");
                    setTxtColorPro("#d53f8c");
                  }}
                >
                  <div
                    class="h-28  text-center p-6"
                    style={{ backgroundColor: colorPro }}
                  >
                    <h3
                      class="text-2xl poppins-bold mb-1"
                      style={{ color: txtColorPro }}
                    >
                      Pro - members
                    </h3>
                  </div>
                  <div class="h-24 w-24 mx-auto -mt-11 shadow-xl rounded-full bg-pink-50 border-2 flex flex-col items-center justify-center border-pink-50">
                    <img src={Reduction} alt="Promo" />
                  </div>
                  <div class="px-6 py-4 mt-4">
                    <p className="text-xl text-pink-600 text-center poppins-regular">
                      Gagner une reduction de 10% sur votre achat pendant 6 mois
                    </p>

                    <button
                      type="button"
                      class="w-full mt-8 px-2 py-2 poppins-semibold text-pink-600 bg-pink-200 hover:bg-pink-600 hover:text-white rounded uppercase transition-all duration-500 hover:scale-105"
                    >
                      Select
                    </button>

                    <p className="text-gray-400 mt-4 text-center">
                      "cliquez sur select et envoie un email pour votre demande"
                    </p>
                  </div>
                </div>

                <div
                  class="shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] rounded-md overflow-hidden transition-all duration-500 hover:scale-105 relative"
                  onMouseEnter={() => {
                    setColorSuper("#d53f8c");
                    setTxtColorSuper("#ffffff");
                  }}
                  onMouseLeave={() => {
                    setColorSuper("#fbcfe8");
                    setTxtColorSuper("#d53f8c");
                  }}
                >
                  <span class="px-4 py-0.5 text-[10px] poppins-semibold text-white bg-orange-400 ml-3 absolute -left-4 top-0">
                    Recommended
                  </span>
                  <div
                    class="h-28 text-center p-6"
                    style={{ backgroundColor: colorSuper }}
                  >
                    <h3
                      class="text-2xl poppins-bold mb-1"
                      style={{ color: txtColorSuper }}
                    >
                      Super - members
                    </h3>
                  </div>
                  <div class="h-24 w-24 mx-auto -mt-11 shadow-xl rounded-full bg-pink-50 border-2 flex flex-col items-center justify-center border-pink-50">
                    <img src={Reduction} alt="Promo" />
                  </div>
                  <div class="px-6 py-4 mt-4">
                    <p className="text-xl text-pink-600 text-center poppins-regular">
                      Gagner une reduction de 10% sur votre achat pendant un an
                    </p>

                    <button
                      type="button"
                      class="w-full mt-8 px-2 py-2 poppins-semibold text-pink-600 bg-pink-200 hover:bg-pink-600 hover:text-white rounded uppercase transition-all duration-500 hover:scale-105"
                    >
                      Select
                    </button>

                    <p className="text-gray-400 mt-4 text-center">
                      "cliquez sur select et envoie un email pour votre demande"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Promo;
